export default function VPNService() {
  const services = [
    {
      icon: 'ri-computer-line',
      title: 'macOS Protection',
      description: 'Complete security for your Mac devices',
      features: [
        'macOS Compatibility',
        'Native Integration',
        'Automatic Updates',
        'Menu Bar Access'
      ]
    },
    {
      icon: 'ri-smartphone-line',
      title: 'iOS Security',
      description: 'Stay protected on your iPhone and iPad',
      features: [
        'iOS App Available',
        'iPad Support',
        'Battery Optimized',
        'One-Tap Connect'
      ],
      featured: true
    }
  ];

  return (
    <section id="vpn-service" className="py-20 lg:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
            <span className="text-sm font-semibold text-orange-500 uppercase tracking-wider">
              OUR SERVICE
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            MILITARY-GRADE<br />ENCRYPTION
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Protecting your data across all platforms
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              className={`bg-white rounded-3xl p-8 transition-all duration-300 ${
                service.featured
                  ? 'shadow-xl scale-105 border-2 border-orange-500'
                  : 'shadow-lg hover:shadow-xl hover:scale-105'
              }`}
            >
              {/* Icon */}
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-6">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>

              {/* Features */}
              <ul className="space-y-3">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center space-x-3">
                    <i className="ri-check-line text-orange-500 text-lg"></i>
                    <span className="text-sm text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
